








import Vue, { PropType } from 'vue';
import { IBusinessCategoryMap } from '@/Store';

export default Vue.extend({
  name: 'CategorySelector',
  props: {
    value: {
      type: Array as PropType<number[]>,
    },
    categories: {
      type: Object as PropType<IBusinessCategoryMap>,
      required: true,
    },
  },
  data() {
    return {
      selectedCategories: this.value,
    };
  },
  watch: {
    value(val: number[]) {
      this.selectedCategories = val;
    },
  },
  methods: {
    onChange(val: number[]) {
      this.$emit('input', val);
    },
  },
});
